import { useCustomTranslation } from '../../../../hooks';
import { GanttQueue, QueueTaskNode } from '../Gantt/types';
import { useFormatTaskDuration, useProductionTaskLocate } from '../Gantt/hooks';
import { TaskMainValueOptions, useProductionPlanSettings } from '../components/SettingsDrawer';
import { ProductionOrderNumber } from '../Gantt/components/NodeBase/ProductionOrderNumber';

type NodeSingleSearchResultProps = {
  node: QueueTaskNode;
  queue: GanttQueue;
};
export const NodeSingleSearchResult = ({ node, queue }: NodeSingleSearchResultProps) => {
  const { tWrapper } = useCustomTranslation('workStation.list');
  const formatTaskDuration = useFormatTaskDuration();
  const showProductName = useProductionPlanSettings((state) => state.taskMainValue === TaskMainValueOptions.PRODUCT);
  const locate = useProductionTaskLocate();

  const productName = showProductName ? node.productName : node.name;

  return (
    <div
      className="flex cursor-pointer items-center justify-between gap-2 border-border-secondary px-6 py-2 not-last:border-b hover:bg-surface-focus-lighter"
      onClick={() =>
        locate({ taskId: node.id, queueId: queue.id, taskStartDate: node.startDate, markAsSearchSelected: true })
      }
    >
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <div className="text-s16-sb">{productName}</div>
          <div className="flex gap-2">
            <ProductionOrderNumber
              productionOrderExternalNumber={node.productionOrderDetails?.externalId}
              productionOrderNumber={node.productionOrderDetails?.number}
            />
          </div>
        </div>
        <div className="text-s11-sb text-text-secondary uppercase">
          <span>{formatTaskDuration(node)}</span>
          <div className="flex gap-x-4">
            <span>{queue.shortName}</span>
            <span>{tWrapper('area', { areaName: queue.area.name })}</span>
          </div>
        </div>
      </div>
      <div className="text-s16 text-nowrap">
        {node.progress.totalAmount.amount} {node.progress.totalAmount.unit.name}
      </div>
    </div>
  );
};
